
<div class="image-container">
  <img src="assets/navimage.png" width="100%" alt="Public Disclosure">
  <div class="image-text">
    <p>Public Disclosure</p>
  </div>
</div>

<div class="container mt-5 pb-4" *ngIf="pageData$ | async">

  <!-- ================= A. GENERAL INFORMATION ================= -->
  <div class="general-info-content"
       [innerHTML]="generalInfoHtml">
  </div>

  <!-- ================= OTHER CATEGORIES (B–E) ================= -->
  <ng-container *ngFor="let category of categories; let i = index">

    <div class="brdr_btm mt-5">
      <span class="content3">
        {{ getSectionLabel(i) }}. {{ category.category }}
      </span>
    </div>

    <table mat-table
          [dataSource]="category.document"
           class="mt-4 mat-table"
           *ngIf="category.document.length">

      <!-- S. No -->
      <ng-container matColumnDef="slno">
        <th mat-header-cell *matHeaderCellDef>S. No.</th>
        <td mat-cell *matCellDef="let row; let idx = index"
            class="brdr"
            [ngClass]="idx % 2 === 0 ? 'even-row' : ''">
          {{ idx + 1 }}
        </td>
      </ng-container>

      <!-- Information -->
      <ng-container matColumnDef="information">
        <th mat-header-cell *matHeaderCellDef>DOCUMENTS / INFORMATION</th>
        <td mat-cell *matCellDef="let row"
            class="brdr">
          {{ row.file?.title }}
        </td>
      </ng-container>

      <!-- Link -->
      <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef>LINK</th>
        <td mat-cell *matCellDef="let row"
            class="brdr highlight-row">
          <a *ngIf="row.file?.fileUUID"
             [href]="getFileUrl(row.file.fileUUID)"
             target="_blank"
             rel="noopener">
            View
          </a>
          <button mat-icon-button (click)="viewFile(row.file)">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsDocs"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsDocs"></tr>

    </table>

        <app-util-file-viewer
          *ngIf="viewFile1"
          [receivedFileFromParent]="viewFile1"
          (newItemEvent)="updateVieFile1()">
        </app-util-file-viewer>
  </ng-container>

</div>

